import moment from "moment";
import "moment-timezone";
import React, { Component } from "react";
import history from "../history";
import LoadingInProgress from "../Shared/LoadingInProgress";
import SeminarsService from "../utils/SeminarsService";
import EditForm from "./EditForm";




class Show extends Component {
  constructor(props) {
    super(props);
    const at = moment()
      .hour(18)
      .minute(40)

    console.log(at)
    this.state = {
      item: {
        location: "",
        at: at,
        capacity: 100,
        status: "hidden"
      }
    };
    this.updateSeminar = this.updateSeminar.bind(this);
  }

  updateSeminar(values) {
    SeminarsService.create(values).then(data => {
      history.push(`/m1/seminars/${data.id}`);
    });
  }

  render() {
    return (
      <div>
        {this.state.item ? (
          <div>
            <div className="row">
              <div className="col-md-6 col-md-offset-3">
                <h1 className="first-title" style={{ marginBottom: "20px" }}>
                  Create New Seminar
                </h1>
                <div className="well">
                  <EditForm
                    item={this.state.item}
                    updateSeminar={this.updateSeminar}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
            <LoadingInProgress message="Loading" />
          )}
      </div>
    );
  }
}
export default Show;
